import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useEffect } from 'react';
import { verticalData } from 'pathfinder/modules/HaloEffectVerticalModule/data/verticalData';
import WikiCard from 'pathfinder/modules/HaloEffectVerticalModule/components/WikiCard';
import Menu from 'pathfinder/modules/HaloEffectVerticalModule/components/Menu';
import { openHaloVerticalMenu, trackHaloEffectClickWikiInVertical, } from 'pathfinder/modules/HaloEffectVerticalModule/tracking';
import { SponsoredWikiCard } from 'pathfinder/modules/shared/SponsoredHaloEffect';
import styles from '../styles/VerticalMenu.module.scss';
const labels = {
    games: 'Top Games Wikis',
    tv: 'Top TV Wikis',
    movies: 'Top Movies Wikis',
    anime: 'Top Anime Wikis',
};
const VerticalMenu = ({ menuPosition, type, onMouseEnter, onMouseLeave, isDarkTheme, isForced, track, }) => {
    if (!verticalData[type] || !menuPosition) {
        return null;
    }
    useEffect(() => {
        openHaloVerticalMenu(track, type);
    }, [type]);
    return (_jsxs(Menu, Object.assign({ top: menuPosition.top, left: menuPosition.left, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, isDarkTheme: isDarkTheme }, { children: [_jsx(SponsoredWikiCard, { verticalType: type, gridLayout: '3-column', track: track, isForced: isForced, isDarkTheme: isDarkTheme }, void 0), _jsx("h4", Object.assign({ className: `${styles.menuTitle} ${isDarkTheme ? styles.menuTitleDark : styles.menuTitleLight}` }, { children: labels[type] }), void 0), _jsx("div", Object.assign({ className: styles.cardList }, { children: verticalData[type].map((wiki) => (_jsx("div", Object.assign({ className: styles.wikiCardWrapper, onClick: () => trackHaloEffectClickWikiInVertical(track, type, wiki.name) }, { children: _jsx(WikiCard, { wikiName: wiki.name, imgUrl: wiki.thumbnail, url: wiki.url, isDarkTheme: isDarkTheme }, void 0) }), wiki.name))) }), void 0)] }), void 0));
};
export default VerticalMenu;
